import { useState, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";

export default function LanguageToggle() {
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const [currentLang, setCurrentLang] = useState("en");



  const changeLangManually = (lang) => {
    const interval = setInterval(() => {
      const combo = document.querySelector(".goog-te-combo");

      if (combo) {
        combo.value = lang;
        combo.dispatchEvent(new Event("change"));
        clearInterval(interval);
      }
    }, 200);
  };

  const handleChange = (lang) => {
    setCurrentLang(lang);
    changeLangManually(lang);
    setShowLangDropdown(false);
  };

  return (
    <>
      {/* hidden google translate */}
      <div id="google_translate_element" style={{ display: "none" }}></div>

      <div className="relative inline-block z-[9999]">
        <button
          onClick={() => setShowLangDropdown((prev) => !prev)}
          className="flex items-center gap-2 px-4 py-2 rounded-lg text-gray-700 bg-white border border-gray-200 hover:bg-gray-50"
        >
          <Globe size={18} />

          <span className="font-semibold text-sm sm:text-base">
            {currentLang === "en"
              ? "EN"
              : currentLang === "hi"
              ? "हि"
              : "मर"}
          </span>

          <ChevronDown
            size={16}
            className={`transition-transform duration-300 ${
              showLangDropdown ? "rotate-180" : ""
            }`}
          />
        </button>

        {showLangDropdown && (
          <div className="absolute right-0 mt-2 w-40 bg-white shadow-xl rounded-lg border border-gray-100 overflow-hidden">
            <button
              onClick={() => handleChange("en")}
              className="w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              English
            </button>

            <button
              onClick={() => handleChange("hi")}
              className="w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              हिन्दी
            </button>

            <button
              onClick={() => handleChange("mr")}
              className="w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              Marathi
            </button>
          </div>
        )}
      </div>
    </>
  );
}